export default "__VITE_ASSET__D0e7DP7E__"